import angular from 'angular';
import Vue from 'vue';
import 'ngVue';

import FranchiseReports from './FranchiseReports.vue';

export default angular
  .module('directives.franchisereports', [])
  .directive('dcFranchiseReports', [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('DcFranchiseReports', FranchiseReports));
    }
  ]);
